import { render, staticRenderFns } from "./compareCollege.vue?vue&type=template&id=2edeb614&scoped=true&"
import script from "./compareCollege.vue?vue&type=script&lang=js&"
export * from "./compareCollege.vue?vue&type=script&lang=js&"
import style0 from "./compareCollege.vue?vue&type=style&index=0&id=2edeb614&lang=less&scoped=true&"
import style1 from "./compareCollege.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edeb614",
  null
  
)

export default component.exports